"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Drawer = _interopRequireDefault(require("@material-ui/core/Drawer"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _IconButton = _interopRequireDefault(require("../IconButton/IconButton"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  padding: 15px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n  padding: 16px 48px 16px 16px;\n  button {\n    display: block;\n    background-color: ", ";\n    margin-left: 0;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  position: absolute;\n  top: 8px;\n  right: 8px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var StyledIconButton = (0, _styledComponents.default)(_IconButton.default)(_templateObject(), function (props) {
  return props.theme.palette.getContrastText(props.theme.palette.secondary.main);
});

var Header = _styledComponents.default.div(_templateObject2(), function (props) {
  return props.theme.palette.secondary.main;
}, function (props) {
  return props.theme.palette.getContrastText(props.theme.palette.secondary.main);
}, function (props) {
  return props.theme.palette.getContrastText(props.theme.palette.secondary.main);
});

var MenuLink = _styledComponents.default.div(_templateObject3());

var Drawer = function Drawer(_ref) {
  var onClose = _ref.onClose,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["onClose", "children"]);

  return _react.default.createElement(_Drawer.default, Object.assign({}, props, {
    onBackdropClick: onClose
  }), _react.default.createElement(StyledIconButton, {
    size: "small",
    "aria-label": "Close",
    onClick: onClose
  }, _react.default.createElement(_Icon.default, {
    name: "close"
  })), children);
};

Drawer.defaultProps = {
  variant: 'temporary',
  anchor: 'left'
};
Drawer.Header = Header;
Drawer.MenuLink = MenuLink;
/** @component */

var _default = Drawer;
exports.default = _default;